import React from 'react';
import { remCss, scssVariables as variables } from 'src/helpers';

const VolumeIcon = React.memo(
  ({
    width = 13.026,
    height = 12.02,
    viewBox = '0 0 13.026 12.02',
    fill = variables['colors-mc-primary'],
    volume = 0
  }) => (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={remCss(width)}
      height={remCss(height)}
      viewBox={viewBox}
    >
      {volume > 2 && (
        <path
          id='Path_11155'
          data-name='Path 11155'
          d='M11.536,14.01a8.5,8.5,0,0,0,0-12.02l-.708.707a7.5,7.5,0,0,1,0,10.606l.708.707Z'
          transform='translate(-1 -1.99)'
          fill={fill}
        />
      )}
      {volume > 1 && (
        <path
          id='Path_11156'
          data-name='Path 11156'
          d='M10.121,12.6a6.5,6.5,0,0,0,0-9.192l-.707.707a5.5,5.5,0,0,1,0,7.779l.706.706Z'
          transform='translate(-1 -1.99)'
          fill={fill}
        />
      )}
      <path
        id='Path_11157'
        data-name='Path 11157'
        d='M8.707,11.182a4.5,4.5,0,0,0,0-6.364L8,5.525a3.5,3.5,0,0,1,0,4.95ZM6.717,3.55A.5.5,0,0,1,7,4v8a.5.5,0,0,1-.812.39L3.825,10.5H1.5A.5.5,0,0,1,1,10V6a.5.5,0,0,1,.5-.5H3.825L6.188,3.61a.5.5,0,0,1,.529-.06Z'
        transform='translate(-1 -1.99)'
        fill={fill}
      />
    </svg>
  )
);
VolumeIcon.displayName = 'VolumeIcon';

export default VolumeIcon;
